export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-laptop-232e4877d2f63b8189efaf73a10068c3.svg";